<template>
  <TitleFrame text="利用規約への同意">
    <template slot="contents">
      <div class="mainContent">
        <div>
          <p>
            本アプリケーション（以下「スイスイ旅」という）は、「観光需要の時空間分散に向けた実証実験」用のものです。
          </p>
          <p class="text-red">
            このアプリでは現在地を含めた経路検索、現在地付近の施設情報の提供をするために、現在地のデータが収集されます。位置情報を常に許可する必要があります。
          </p>
          <p>
            取得されたデータは、個人を特定できない形式に加工され、研究目的以外に使用しません。
            ご利用に際し、利用規約とプライバシーポリシーをご確認ください。
          </p>
          <div>
            <ButtonTextLink
              isBlack
              text="利用規約"
              @click-text="onClickKiyaku"
            />
            <ButtonTextLink
              isBlack
              text="プライバシーポリシー"
              @click-text="onClickPrivacy"
            />
          </div>
          <div>
            <ButtonTextLink text="同意して進む" @click-text="onClickAgree" />
          </div>
        </div>
      </div>
    </template>
  </TitleFrame>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import TitleFrame from "@/components/Templates/TitleFrame";
import ButtonTextLink from "@/components/Atoms/ButtonTextLink";

export default {
  name: "consent-page",
  components: {
    TitleFrame,
    ButtonTextLink,
  },
  computed: {
    ...mapState([]),
  },
  methods: {
    ...mapMutations(["loadingStartMini", "loadingEndMini", "setCurrentLatLng"]),
    onClickKiyaku() {
      window.open(
        "https://www.suisuitabi.org/スイスイ旅山梨版/利用規約",
        "_blank",
      );
    },
    onClickPrivacy() {
      window.open(
        "https://www.suisuitabi.org/スイスイ旅山梨版/プライバシーポリシー",
        "_blank",
      );
    },
    async onClickAgree() {
      this.loadingStartMini();
      let setCurrentLatLng = this.setCurrentLatLng;
      let router = this.$router;
      let loadingEndMini = this.loadingEndMini;

      navigator.geolocation.getCurrentPosition(
        async function (position) {
          setCurrentLatLng({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
          loadingEndMini();
          router.push({ name: "Branch" });
        },
        async function (err) {
          var msgs = [
            err.message,
            "位置情報の取得を許可されていません。",
            "位置情報の取得に失敗しました。",
            "位置情報を取得中にタイムアウトしました。",
          ];
          window.alert(msgs[err.code]);

          loadingEndMini();
        },
        { maximumAge: 0 },
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";
.mainContent {
  padding: 0 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/Consent.vue